var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("Pagina niet gevonden.")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ path: '/' }}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }